// 重定向到重构后的通知服务
import notificationServiceInstance, { 
  NotificationService as NotificationServiceClass,
  PermissionStatus,
  NotificationOptions,
  ReceivedNotification,
  Subscription,
  PendingNotification,
  DeliveredNotification,
  NotificationChannel,
  NotificationAction,
  NotificationAttachment
} from './notification';

// 重新导出所有类型
export type {
  PermissionStatus,
  NotificationOptions,
  ReceivedNotification,
  Subscription,
  PendingNotification,
  DeliveredNotification, 
  NotificationChannel,
  NotificationAction,
  NotificationAttachment
};

// 导出带有getInstance方法的兼容API
export const NotificationService = {
  getInstance: () => notificationServiceInstance
};

// 默认导出通知服务实例
export default notificationServiceInstance; 